<ng-container [ngSwitch]="country">
	<!-- Mexico -->
	<ng-container *ngSwitchCase="ECountry.mexico">
		<span class="Flag Flag--mexico" [style.width.px]="width" [style.height.px]="height"></span>
	</ng-container>

	<ng-container *ngSwitchDefault>not support -{{ country }} </ng-container>
</ng-container>
